import { faChevronDown } from "@fortawesome/pro-solid-svg-icons/faChevronDown";
import { faCircleInfo } from "@fortawesome/pro-solid-svg-icons/faCircleInfo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ActionIcon, Flex, Select, Tooltip } from "@mantine/core";

import { ROLE_DESCRIPTIONS, UserRole } from "@/types/user";

const ROLE_OPTIONS = [
  { value: UserRole.Admin, label: "Admin" },
  { value: UserRole.Editor, label: "Editor" },
  { value: UserRole.Reviewer, label: "Reviewer" },
];

interface RoleSelectProps {
  disabled?: boolean;
  onChange?: (role: UserRole) => void;
  role?: UserRole | null;
}

export const RoleSelect = ({ disabled, onChange, role }: RoleSelectProps) => {
  const selectedOption = role
    ? ROLE_OPTIONS.find((opt) => opt.value === role)
    : null;

  return (
    <Flex align="center" gap={12}>
      <Select
        allowDeselect={false}
        classNames={{
          root: "w-36",
          input: "border-uw-gray-2 h-10 rounded text-sm",
          dropdown: "rounded shadow-[0px_0px_12px_0px_rgba(0,0,0,0.1)]",
          option: "p-3 border-b border-uw-gray-0 last:border-b-0",
        }}
        comboboxProps={{ width: 236, position: "bottom-start" }}
        disabled={disabled}
        maxDropdownHeight={400}
        data={ROLE_OPTIONS}
        onChange={(value) => {
          if (value && onChange) {
            onChange(value as UserRole);
          }
        }}
        placeholder="Select role"
        renderOption={({ option }) => (
          <Flex direction="column" gap={3}>
            <span className="text-sm text-uw-gray-9">{option.label}</span>
            <span className="text-xs text-uw-gray-5">
              {ROLE_DESCRIPTIONS[option.value as UserRole]}
            </span>
          </Flex>
        )}
        rightSection={<FontAwesomeIcon icon={faChevronDown} size="xs" />}
        rightSectionPointerEvents="none"
        value={role}
        withCheckIcon={false}
      />
      {selectedOption && (
        <Tooltip
          label={ROLE_DESCRIPTIONS[selectedOption.value as UserRole]}
          multiline
          w={220}
        >
          <ActionIcon variant="transparent" c="purple.5" size="sm">
            <FontAwesomeIcon icon={faCircleInfo} />
          </ActionIcon>
        </Tooltip>
      )}
    </Flex>
  );
};
